import React from 'react';
import Group from './script/Group';

const ScriptGeneratorClassifier2Choice = ({scripts, items, parameters, extraFields}) => (
    <>
        {scripts.map((script, index) => (
            <div key={index} className="row align-items-center">
                <Group expressions={script.expression} items={items} parameters={parameters} extraFields={extraFields} />
            </div>
        ))}
    </>
);

export default ScriptGeneratorClassifier2Choice;
